import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Deposit from './pages/Deposit';
import CashBack from './pages/CashBack';
import Rebate from './pages/Rebate';
import Referral from './pages/Referral';
import Withdraw from './pages/Withdraw';
import Promotion from './pages/Promotion';
import AboutUs from './pages/AboutUs';
import Login from './pages/Login';
import Register from './pages/Register';
import WebLogin from './pages/WebLogin';
import SetPassword from './pages/SetPassword';
import BankTransferDeposit from './components/WalletPage/BankTransferDeposit';
import BankTransferWithdraw from './components/WalletPage/BankTransferWithdraw';
import PaymentGatewayDeposit from './components/WalletPage/PaymentGatewayDeposit';
import CryptoAddress from './components/WalletPage/CryptoAddress';
import PaymentGatewayWithdraw from './components/WalletPage/PaymentGatewayWithdraw';
import Wallet from './components/WalletPage/Wallet';
import CryptoWithdraw from './components/WalletPage/CryptoWithdraw';
import CryptoDeposit from './components/WalletPage/CryptoDeposit';
import GlobalLoader from "./components/GlobalLoader";
import RequireAuth from "./components/RequireAuth";
import { AuthProvider } from './context/AuthContext';
import { ModalProvider } from "./context/ModalContext";
import { LoadingProvider } from "./context/LoadingContext"; 
import { TelegramProvider } from './context/TelegramContext';
import { LanguageProvider } from './context/LanguageContext';
import { useAuth } from './context/AuthContext';
import i18n from './i18n';

function ReferralLandingRedirect() {
    const location = useLocation();
    const navigate = useNavigate();
    const { token } = useAuth();

    useEffect(() => {
        if (token) {
            return;
        }

        if (location.pathname !== "/") {
            return;
        }

        const params = new URLSearchParams(location.search);
        const referral = params.get("start") || params.get("referral");

        if (referral) {
            navigate(`/register?start=${encodeURIComponent(referral)}`, { replace: true });
        }
    }, [location.pathname, location.search, navigate, token]);

    return null;
}

function MainApp() {
    const location = useLocation();

    return (
        <div className="min-h-screen">
            <ReferralLandingRedirect />
            <Routes location={location} key={location.pathname + location.key}>
                <Route path="/" element={<HomePage />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/auth/web-login" element={<WebLogin />} />

                <Route path="/cash-back" element={<CashBack />} />
                <Route path="/rebate" element={<Rebate />} />
                <Route path="/promotion" element={<Promotion />} />
                <Route path="/referral" element={<Referral />} />

                <Route element={<RequireAuth />}>
                    <Route path="/set-password" element={<SetPassword />} />
                    <Route path="/change-password" element={<SetPassword mode="change" />} />
                    <Route path="/deposit" element={<Deposit />} />
                    <Route path="/withdraw" element={<Withdraw />} />
                    <Route path="/wallet" element={<Wallet />} />
                    <Route path="/crypto-withdraw" element={<CryptoWithdraw />} />
                    <Route path="/bank-transfer-deposit" element={<BankTransferDeposit />} />
                    <Route path="/bank-transfer-withdraw" element={<BankTransferWithdraw />} />
                    <Route path="/payment-gateway-withdraw" element={<PaymentGatewayWithdraw />} />
                    <Route path="/payment-gateway-deposit" element={<PaymentGatewayDeposit />} />
                    <Route path="/crypto-deposit" element={<CryptoDeposit />} />
                    <Route path="/crypto-address" element={<CryptoAddress />} />
                </Route>
            </Routes>
        </div>
    );
}

function AppWrapper() {
    return (
        <TelegramProvider>
            <AuthProvider>
                <ModalProvider> {/* ✅ Wrap the entire app with ModalProvider */}
                    <LoadingProvider>
                        <I18nextProvider i18n={i18n}>
                            <LanguageProvider>
                                <Router>
                                    <GlobalLoader />
                                    <MainApp />
                                </Router>
                            </LanguageProvider>
                        </I18nextProvider>
                    </LoadingProvider>
                </ModalProvider>
            </AuthProvider>
        </TelegramProvider>
    );
}

export default AppWrapper;